import { GET_INTERVIEW_RESPONSE_ANSWER_SCORES } from "graphql/queries";
import { useQueryData } from "hooks";

/**
 * useInterviewResponseAnswerScores
 *
 * @param {String} interviewResponseAnswerIds
 * @param {Boolean} skip
 */
export default function useInterviewResponseAnswerScores({ interviewResponseAnswerIds, skip }) {
  const { data, loading, error } = useQueryData({
    queryName: GET_INTERVIEW_RESPONSE_ANSWER_SCORES,
    keyName: "interviewResponseAnswerScores",
    variables: { interviewResponseAnswerIds },
    skip,
  });

  return { data: data?.interviewResponseAnswerScores, loading, error };
};
